/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        return function() {
            return {
                trafficViewport: requestFactory.single(endpoints.trafficViewport, ApiKeyNames.traffic)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/trafficViewport.js